import apiRoutes from './api.routes';
import ModelService from './model.service';

const PostCategoryService = new ModelService(apiRoutes.postsCategories, '/posts-categories', 'blog');

PostCategoryService.getImage = (filename, w = false, h = false, c = false) => PostCategoryService.getFilePathByDir('/uploads/posts', filename, w, h, c);

export default PostCategoryService;



// WEBPACK FOOTER //
// ./src/services/postCategory.service.js